<template>
    <div :id="id" class="lam-cards" :class="{'lam-cards-tall': tall, 'lam-cards-flex': flex}">
        <!-- filter by //-->
        <div v-if="filterValues&&filterValues.length" class="uk-clearfix">
            <ul :id="filters_id" class="uk-subnav uk-subnav-line uk-float-right">
                <li :class="{'uk-active': !filter}" data-uk-filter=""><a href @click.prevent="filter_applied('')">All</a></li>
                <li v-for="filter_value in filterValues" :key="filter_value" :class="{'uk-active': filter===filter_value}" :data-uk-filter="filter_value"><a href @click.prevent="filter_applied(filter_value)">{{ filter_value }}</a></li>
            </ul>
        </div>

        <!-- loop over items and call template slot for each //-->
        <div :class="{'uk-grid-match': flex}" :data-uk-grid-match="grid_match" class="uk-grid uk-grid-small">
            <div v-for="card in cards" :key="card_id(card)" :id="card_id(card)" v-show="!filter||filter===card[filterOn]" :class="card_classes(card)" class="lam-card">
                <div :class="{'uk-selected': card_selected(card)}" class="uk-panel uk-panel-box">
                    <div v-if="!!card_title(card)" class="uk-grid uk-grid-small uk-margin-bottom">
                        <div :class="{'uk-width-1-3': has_toc&&has_actions, 'uk-width-1-2': (!has_toc && !!has_actions) || (!!has_toc && !has_actions), 'uk-width-1-1': !has_toc&&!has_actions}">
                            <h3 class="uk-panel-title uk-margin-small-top">
                                <router-link
                                    v-if="!!card.route"
                                    :to="card.route"
                                >
                                    <span>{{ card_title(card) }}</span>
                                </router-link>
                                <span v-else>
                                    <input v-if="selectable" type="checkbox" :value="card_id(card)" v-model="selection" class="uk-margin-right" />
                                    <span v-html="card_title(card)"></span>
                                </span>
                            </h3>
                        </div>
                        <div v-if="has_toc" :class="{'uk-width-1-3': has_toc&&has_actions, 'uk-width-1-2': !has_actions}" class="uk-text-center">
                            <slot name="card-toc" :card="card"></slot>
                        </div>
                        <div v-if="has_actions" :class="{'uk-width-1-3': has_toc&&has_actions, 'uk-width-1-2': !has_toc}" class="uk-text-right" style="padding-top: 4px;">
                            <slot name="card-actions" :card="card"></slot>
                        </div>
                    </div>
                    <!--<hr v-if="!!card_title(card)">//-->
                    <div class="lam-card-body">
                        <slot name="card" :card="card"></slot>
                    </div>
                    <div class="lam-card-footer">
                        <slot name="card-footer" :card="card"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import { orderBy } from "lodash"

export default {
    watch: {
        selection: "selection_changed"
    },
    props: {
        id: {
            type: String,
            required: true
        },
        cards: {
            type: Array,
            required: true
        },
        selectable: {
            type: Boolean,
            default: false
        },
        filterOn: {
            type: String,
            default: ""
        },
        filterValues: {
            type: Array
        },
        tall: {
            type: Boolean,
            default: false
        },
        flex: {
            type: Boolean,
            default: false
        },
        singleMode: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            filter: "",
            selection: []
        }
    },
    computed: {
        filters_id () {
            return this.id + "-filters"
        },
        grid_match () {
            if(!this.flex) return false
            return "{target:'.uk-panel'}"
        },
        has_toc () {
            return !!this.$scopedSlots && !!this.$scopedSlots["card-toc"]
        },
        has_actions () {
            return !!this.$scopedSlots && !!this.$scopedSlots["card-actions"]
        }
    },
    methods: {
        selection_changed () {
            this.$emit("selection-changed", this.selection)
        },
        filter_applied (filter) {
            this.filter = filter
        },
        card_id (card, suffix) {
            if(!card) return ""
            if(!card.entity) return card.id
            return card.entity + "-" + card.id + (suffix || "")
        },
        card_title (card) {
            if(!card || card.titleless) return ""
            const title = card.title || card.type

            return title
        },
        card_selected (card) {
            return this.selection.indexOf(this.card_id(card)) >= 0
        },
        card_classes (card) {
            if(this.singleMode) return { "uk-width-1-1": true }
            return card.classes || { "uk-width-small-1-1": true, "uk-width-medium-1-3": true }
        },
        revisions (card) {
            if(!card.revisions_entity) return []
            const collection = this.$store.getters[card.revisions_entity + "_records"].filter((revision) => {
                return revision[card.entity + "_id"] === card.record.id
            })
            return (collection && collection.length) ? orderBy(collection, "created_at", "desc") : [{}]
        }
    }
}
</script>
